import React, { FC } from "react";

type NewBadgeProps = {
    text?: "Новое" | "Новинка";
    className?: string;
};

export const NewBadge: FC<NewBadgeProps> = ({
                                                text = "Новое",
                                                className = "",
                                            }) => {
    return (
        <span
            className={`inline-flex items-center rounded-full bg-[#ffe7f3] px-2 py-[2px] text-[10px] font-semibold leading-none text-[#c06198] ${className}`}
        >
      {text}
    </span>
    );
};
